export default "__VITE_ASSET__DlsQKfgK__"